module.exports = __webpack_public_path__ + "static/media/Week9.5ede2dd3.pdf";